<template>
  <v-row class="appBarComp ma-0" justify="space-between">
    <v-sheet
      color="transparent"
      :style="smAndDown ? 'width: 150px ' : 'width: calc(100% - 200px);'"
    >
      <v-sheet color="transparent" width="630">
        <v-row class="ma-0">
          <v-sheet width="90" color="transparent" height="65">
            <v-app-bar-nav-icon
              v-if="mdAndDown"
              class="mt-2"
              color="white"
              variant="text"
              @click="changeDrawer()"
            ></v-app-bar-nav-icon>
          </v-sheet>
          <span
            v-if="mdAndUp && projectName !== 'SmartLinkRAOS'"
            class="mt-5 ml-4 textappBAR"
          >
            SMARTLINK V2.6 | <span class="preTitle"> {{ finaltitleBar }} </span>
          </span>
          <span
            v-if="mdAndUp && projectName === 'SmartLinkRAOS'"
            class="mt-5 ml-4 textappBAR"
          >
            SMARTLINK RAOS
            </span>
        </v-row>
      </v-sheet>
    </v-sheet>
    <v-sheet class="languageCard" color="transparent">
      <v-row class="ma-0 py-3" justify="end" align-content="center">
        <v-select
          class="languageSelect"
          v-if="!xs"
          v-model="locale"
          :items="language"
          item-title="title"
          item-value="value"
          density="compact"
          variant="outlined"
          hide-details
          style="width: 110px !important"
        >
        </v-select>

        <v-menu :close-on-content-click="false" transition="slide-x-transition">
          <template v-slot:activator="{ props, isActive }">
            <v-btn
              :append-icon="isActive ? 'mdi-chevron-left' : 'mdi-chevron-down'"
              color="colorText"
              v-bind="props"
            >
              <v-icon icon="mdi-cog-outline"></v-icon>
            </v-btn>
          </template>
          <v-list :lines="false" density="compact" nav>
            <!-- Theme Switch -->
            <v-list-item>
              <v-switch
                v-model="themeSwitch"
                append-icon="mdi-weather-night"
                prepend-icon="mdi-white-balance-sunny"
                hide-details
              >
              </v-switch>
            </v-list-item>
            <v-list-item v-if="xs">
              <v-select
                class="mb-3"
                v-model="locale"
                :items="language"
                item-title="title"
                item-value="value"
                density="compact"
                variant="outlined"
                hide-details
                style="width: 110px !important"
              >
              </v-select>
            </v-list-item>
            <v-list-item
              :style="'text-align:center'"
              v-for="(item, i) in items"
              :key="i"
              link
              @click="pressItem(i)"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-row>
    </v-sheet>
  </v-row>
</template>

<script setup lang="ts">
import { computed, onMounted, Ref, ref, watch } from "vue";
import router from "@/router";

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useTheme, useDisplay } from "vuetify";
const { xs, mdAndUp, mdAndDown, smAndDown } = useDisplay();
const theme = useTheme();

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from "vuex";
const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from "vue-i18n";
let { locale, t } = useI18n();

/********************************
 ********** INTERFACES **********
 *******************************/
import { STRINGS } from "@/interfaces/SmartLink/General";

/**
 * Component
 */
const nameBar: Ref<STRINGS> = ref({
  SmartLinkAntucoya: "MINERA ANTUCOYA",
  SmartLinkZaldivar: "MINERA ZALDIVAR",
  SmartLinkMaster: "MINERA CANANEA",
  SmartLinkCananea: "MINERA CANANEA",
  SmartLinkNacozari: "MINERA NACOZARI",
  SmartLinkHCGROUP: "MINERA DEMO",
  SmartLinkDEMO: "MINERA DEMO",
  SmartLinkMasterFront: "MINERA DEMO",
  SmartLinkCMDIC: "MINERA CMDIC",
  SmartLinkIOT: "MINERA IOT",
  SmartLinkTepeaca: "CEMENTERA TEPEACA"
});

const projectName = computed(() => store.state.projectName);
const finaltitleBar = ref(nameBar.value[projectName.value ?? ""]);

const colorPick = ref(null);

const items = ref([
  { title: computed(() => t("logout")) },
  // {title : computed( () => t('logout') )}
]);
const language = ref([
  { title: computed(() => t("appBar.es")), value: "es" },
  { title: computed(() => t("appBar.en")), value: "en" },
]);

const themeSwitch = ref(false);

watch(themeSwitch, (p: boolean) => {
  setTimeout(() => {
    localStorage.setItem("appTheme", p.toString());
    let themeSelect = "";
    p ? (themeSelect = "darkCustom") : (themeSelect = "lightCustom");
    theme.change(themeSelect)
  }, 100);
});

watch(colorPick, (color) => {
  if (theme.global.name.value === "darkCustom") {
    theme.themes.value.darkCustom.colors.background = color ?? "";
  }
  if (theme.global.name.value === "lightCustom") {
    theme.themes.value.lightCustom.colors.background = color ?? "";
  }
});

const changeDrawer = () => {
  store.commit("showDrawer");
};

const pressItem = (item: number) => {
  if (item === 0) { // Cerrar Sesión
    // 1. Obtener el rol guardado en LocalStorage
    const userRol = localStorage.getItem("rol");

    // 2. Redireccionar según el rol del usuario
    if (userRol === "desarrollador") {
      // Si es programador/desarrollador, va a la selección de minas
      router.push("/principalPage");
      store.commit("setAppBarPage", "principalPage");
    } else {
       localStorage.removeItem("user");
      localStorage.removeItem("rol");
      store.commit("setUserSesion", null);
      // store.commit("setUserRol", null);
      // Si es trabajador de mina (o cualquier otro usuario), va al Login
      router.push("/login");
      store.commit("setAppBarPage", "loginPage");
    }

    theme.change("darkCustom");
  }
  if (item === 1) {
    if (theme.global.name.value === "darkCustom") {
      theme.themes.value.darkCustom.colors.background = "#FF00FF";
    }
    if (theme.global.name.value === "lightCustom") {
      theme.themes.value.lightCustom.colors.background = "#FF0000";
    }
  }
};

onMounted(() => {
  let themeSelect = "";
  localStorage.getItem("appTheme") === null
    ? localStorage.setItem("appTheme", "true")
    : null;
  setTimeout(() => {
    themeSwitch.value = localStorage.getItem("appTheme")?.toString() === "true";
    themeSwitch.value
      ? (themeSelect = "darkCustom")
      : (themeSelect = "lightCustom");
    theme.global.name.value = themeSelect;
  }, 500);
});
</script>

<style>
.badgeAlerts:hover {
  cursor: pointer;
}

.v-toolbar__content .v-img__img {
  width: auto !important;
}

.select_language {
  border: 1px solid white;
  border-radius: 10px;
  padding: 0 10px;
}
.select_language:hover {
  cursor: pointer;
}
.select_language option {
  color: black !important;
}
span.preTitle {
  letter-spacing: 5px;
  font-weight: 400;
  font-size: 16px;
  height: max-content;
  font-family: "Poppins", sans-serif;
}
header {
  left: 0 !important;
  width: 100% !important;
}

.appBarComp .v-btn--size-default {
  padding: 0px !important;
}

.appBarComp .v-field.v-field--appended {
  grid-template-columns: 0;
  --v-field-padding-end: 0px !important;
}
.languageCard .languageSelect .v-field {
  padding: 0;
}
</style>
